import React from 'react';
import {IApplication} from "../../Interfaces/Application/IApplication";
import {getNamesOfCustomersThatNeedAHardPull} from "../../utils/utils";
import BypassableErrorDialog from "./BypassableErrorDialog";
import {DialogOption} from "@amsanalytics/react-shared-library/build/providers/DialogProvider";

// Returning true or false means that the user had a choice. Returning undefined means that there were no applicants that needed a hard pull
export const ConfirmHardPullRequirement = (currentApp: IApplication, openDialog: (option: DialogOption) => void, closeDialog: () => void): Promise<boolean | undefined> => {
  const applicantNamesThatNeedHardPull = getNamesOfCustomersThatNeedAHardPull(currentApp!);
  
    return new Promise(resolve => {
      if (applicantNamesThatNeedHardPull.length > 0) {
        openDialog({
          fullScreen: false,
          children: (
            <BypassableErrorDialog
              title='Desking Without Hard Pull Notice'
              bodyText={"You can't desk the deal because you have not performed a hard credit pull for the following applicant(s). Click bypass if you are confirming that you have done a hard credit pull from another system."}
              errors={applicantNamesThatNeedHardPull}
              confirmationCheckboxText={"Hard credit was pulled from another system"}
              closeDialog={() => {
                closeDialog();
                resolve(false);
              }}
              allowBypass={true}
              accept={() => resolve(true)}
            />
          )
        });
      } else {
        resolve(undefined);
      }
    });
}
